<div mat-dialog-title class="dialog-header">
    <mat-icon class="close-icon" (click)="closeDialog()">close_icon</mat-icon>
</div>

<div class="container dialog-content">
    <form [formGroup]="formGroup">
        <div class="form-field-row">
            <div>
                <aum-select
                    placeholder="{{ 'aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options' | i18next }}"
                    [options]="data"
                    [aumFormControl]="formGroup.controls['ofThatItems']"
                    [propertyOfOptionToDisplay]="'caption'"
                    [propertyOfOptionId]="'name'"
                    [multiple]="true"
                >
                    <aum-form-field-label>
                        {{ 'aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options_label' |
                        i18next }}
                    </aum-form-field-label>
                </aum-select>
            </div>
        </div>
    </form>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button
            aum-button
            (click)="onSaveClicked()"
            [disabled]="this.formGroup?.get('ofThatItems')?.value.length === 0 || this.formGroup?.get('ofThatItems')?.value.includes(undefined)"
            color="primary"
        >
            {{ 'aumico_templates_group_account_mapping_duplicate_account_form_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
